export default __webpack_public_path__ + "static/media/stands_ind_-lutron.ef98582c.jpg";